"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8639],{

/***/ 84525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ BaseCell; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var baseui_layout_grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69530);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58817);
/* harmony import */ var _hooks_use_space__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16333);







var BaseCell = function(_param) {
    var style = _param.style, children = _param.children, overrides = _param.overrides, spaceTop = _param.spaceTop, spaceBottom = _param.spaceBottom, _span = _param.span, span = _span === void 0 ? [
        4,
        8,
        12
    ] : _span, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "style",
        "children",
        "overrides",
        "spaceTop",
        "spaceBottom",
        "span"
    ]);
    var ref = (0,_hooks_use_space__WEBPACK_IMPORTED_MODULE_2__/* .useSpace */ .$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = ref.marginTop, marginBottom = ref.marginBottom;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_layout_grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__/* .useOverrides */ .Q)({
            Cell: {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, marginTop, marginBottom, style)
            }
        }, overrides),
        span: span
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 83825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ BaseGrid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var baseui_layout_grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54702);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58817);
/* harmony import */ var _hooks_use_space__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16333);







var BaseGrid = function(_param) {
    var style = _param.style, children = _param.children, overrides = _param.overrides, spaceTop = _param.spaceTop, spaceBottom = _param.spaceBottom, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "style",
        "children",
        "overrides",
        "spaceTop",
        "spaceBottom"
    ]);
    var ref = (0,_hooks_use_space__WEBPACK_IMPORTED_MODULE_2__/* .useSpace */ .$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = ref.marginTop, marginBottom = ref.marginBottom;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_layout_grid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_6__/* .useOverrides */ .Q)({
            Grid: {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    boxSizing: "content-box"
                }, marginTop, marginBottom, style)
            }
        }, overrides)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 53321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HR": function() { return /* binding */ HeadingS; },
/* harmony export */   "Kz": function() { return /* binding */ HeadingXS; },
/* harmony export */   "_n": function() { return /* binding */ HeadingXL; },
/* harmony export */   "aw": function() { return /* binding */ HeadingM; },
/* harmony export */   "iI": function() { return /* binding */ HeadingL; }
/* harmony export */ });
/* unused harmony export HeadingXXL */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var baseui_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94858);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32317);







var HeadingXXL = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? colors.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = _object_without_properties(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return _jsx(HeadingXXLarge, _object_spread_props(_object_spread({
        font: [
            "MobileHeadingXXL",
            "MobileHeadingXXL",
            "TabletHeadingXXL",
            "HeadingXXL", 
        ],
        $style: _object_spread({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
})));
var HeadingXL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .HeadingXLarge */ .lp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: [
            "MobileHeadingXL",
            "MobileHeadingXL",
            "TabletHeadingXL",
            "HeadingXL", 
        ],
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var HeadingL = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .HeadingLarge */ .Ih, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: [
            "MobileHeadingL",
            "MobileHeadingL",
            "TabletHeadingL",
            "HeadingL"
        ],
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var HeadingM = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .HeadingMedium */ .TE, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: [
            "MobileHeadingM",
            "MobileHeadingM",
            "TabletHeadingM",
            "HeadingM"
        ],
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var HeadingS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .HeadingSmall */ .Jf, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "HeadingS",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});
var HeadingXS = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, weight = _param.weight, align = _param.align, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray700 */ .O.gray700 : _color, whiteSpace = _param.whiteSpace, $style = _param.$style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "weight",
        "align",
        "color",
        "whiteSpace",
        "$style"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_typography__WEBPACK_IMPORTED_MODULE_4__/* .HeadingXSmall */ .fH, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        font: "HeadingXS",
        $style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            fontWeight: weight,
            textAlign: align,
            whiteSpace: whiteSpace
        }, $style),
        color: color
    }, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 5516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/routes.ts
var routes = __webpack_require__(78954);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(32317);
// EXTERNAL MODULE: ./node_modules/baseui/esm/block/block.js + 1 modules
var block = __webpack_require__(81480);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./node_modules/styletron-react/dist-browser-esm/index.js
var dist_browser_esm = __webpack_require__(54511);
// EXTERNAL MODULE: ./components/base-cell/base-cell.tsx
var base_cell = __webpack_require__(84525);
// EXTERNAL MODULE: ./components/base-grid/base-grid.tsx
var base_grid = __webpack_require__(83825);
// EXTERNAL MODULE: ./components/base-typography/label.tsx
var base_typography_label = __webpack_require__(67408);
// EXTERNAL MODULE: ./components/base-typography/paragraph.tsx
var paragraph = __webpack_require__(88292);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/svg/stores/apple-store.svg
var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgAppleStore(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 130,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 6a6 6 0 016-6h118a6 6 0 016 6v28a6 6 0 01-6 6H6a6 6 0 01-6-6V6z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.768 20.58a4.95 4.95 0 012.357-4.151 5.066 5.066 0 00-3.992-2.158c-1.679-.176-3.307 1.005-4.162 1.005-.873 0-2.19-.988-3.609-.958a5.315 5.315 0 00-4.473 2.727c-1.934 3.349-.491 8.27 1.361 10.976.927 1.326 2.01 2.806 3.428 2.754 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.851 1.489-.024 2.427-1.33 3.32-2.669a10.963 10.963 0 001.52-3.092 4.782 4.782 0 01-2.92-4.4zM23.036 12.49A4.872 4.872 0 0024.15 9a4.957 4.957 0 00-3.207 1.66 4.636 4.636 0 00-1.144 3.361 4.099 4.099 0 003.237-1.53z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M41.557 13.78V8.794h1.44c.396 0 .729.057.999.171.27.108.489.27.657.486.174.21.297.468.369.774.078.3.117.642.117 1.026 0 .396-.042.735-.126 1.017a2.39 2.39 0 01-.306.693c-.126.186-.27.333-.432.441a2.151 2.151 0 01-.477.252c-.162.054-.315.09-.459.108a4.473 4.473 0 01-.36.018h-1.422zm-.855-5.706V14.5h2.205c.534 0 .996-.075 1.386-.225.39-.15.711-.366.963-.648.252-.288.438-.639.558-1.053.12-.42.18-.9.18-1.44 0-1.032-.267-1.8-.801-2.304-.534-.504-1.296-.756-2.286-.756h-2.205zm6.949 4.104c0-.282.036-.531.108-.747.078-.222.183-.408.315-.558a1.334 1.334 0 011.026-.459c.198 0 .384.039.558.117.18.078.336.192.468.342.132.15.234.336.306.558.078.216.117.465.117.747s-.04.534-.117.756a1.572 1.572 0 01-.306.549 1.363 1.363 0 01-.468.333 1.411 1.411 0 01-1.125 0 1.387 1.387 0 01-.46-.333 1.689 1.689 0 01-.314-.549 2.447 2.447 0 01-.108-.756zm-.81 0c0 .342.048.66.144.954.096.294.24.552.432.774.192.216.429.387.71.513.283.12.607.18.973.18.372 0 .696-.06.972-.18.282-.126.519-.297.71-.513.193-.222.337-.48.433-.774.096-.294.144-.612.144-.954 0-.342-.048-.66-.144-.954-.096-.3-.24-.558-.432-.774a2.01 2.01 0 00-.711-.522 2.322 2.322 0 00-.972-.189c-.366 0-.69.063-.972.189a2.01 2.01 0 00-.711.522 2.121 2.121 0 00-.432.774 3.057 3.057 0 00-.144.954zM57.049 14.5l1.485-4.653h-.792l-1.044 3.807h-.018l-.972-3.807h-.837l-.936 3.807h-.018l-1.053-3.807h-.846l1.494 4.653h.828l.936-3.699h.018l.945 3.699h.81zm2.392-4.653V14.5h.765v-2.628c0-.21.027-.402.081-.576.06-.18.147-.336.261-.468.114-.132.255-.234.423-.306.174-.072.378-.108.612-.108.294 0 .525.084.693.252.168.168.252.396.252.684v3.15h.765v-3.06c0-.252-.027-.48-.08-.684a1.262 1.262 0 00-.262-.54 1.258 1.258 0 00-.495-.351 2.02 2.02 0 00-.765-.126c-.69 0-1.194.282-1.512.846h-.018v-.738h-.72zm5.226-1.773V14.5h.765V8.074h-.765zm2.688 4.104c0-.282.036-.531.108-.747.078-.222.183-.408.315-.558a1.334 1.334 0 011.026-.459c.198 0 .384.039.558.117.18.078.336.192.468.342.132.15.234.336.306.558.078.216.117.465.117.747s-.039.534-.117.756a1.572 1.572 0 01-.306.549 1.363 1.363 0 01-.468.333 1.411 1.411 0 01-1.125 0 1.387 1.387 0 01-.459-.333 1.689 1.689 0 01-.315-.549 2.447 2.447 0 01-.108-.756zm-.81 0c0 .342.048.66.144.954.096.294.24.552.432.774.192.216.43.387.711.513.282.12.606.18.972.18.372 0 .696-.06.972-.18.282-.126.52-.297.711-.513.192-.222.336-.48.432-.774.096-.294.144-.612.144-.954 0-.342-.048-.66-.144-.954-.096-.3-.24-.558-.432-.774a2.01 2.01 0 00-.71-.522 2.322 2.322 0 00-.973-.189c-.366 0-.69.063-.972.189a2.01 2.01 0 00-.71.522 2.121 2.121 0 00-.433.774 3.057 3.057 0 00-.144.954zm9.722 2.304c-.132.078-.315.117-.549.117a.686.686 0 01-.477-.162c-.114-.114-.17-.297-.17-.549-.21.252-.457.435-.739.549a2.448 2.448 0 01-.9.162c-.21 0-.41-.024-.603-.072a1.394 1.394 0 01-.486-.225 1.13 1.13 0 01-.333-.396 1.422 1.422 0 01-.117-.603c0-.264.045-.48.135-.648.09-.168.207-.303.351-.405.15-.108.318-.189.504-.243.192-.054.387-.099.585-.135.21-.042.408-.072.594-.09a4.3 4.3 0 00.504-.09.913.913 0 00.342-.171c.084-.078.126-.189.126-.333a.736.736 0 00-.099-.405.607.607 0 00-.243-.234.946.946 0 00-.333-.108 2.424 2.424 0 00-.36-.027c-.324 0-.594.063-.81.189-.216.12-.333.351-.35.693h-.766c.012-.288.072-.531.18-.729.108-.198.252-.357.432-.477.18-.126.384-.216.612-.27.234-.054.483-.081.747-.081.21 0 .417.015.621.045.21.03.4.093.567.189.168.09.303.219.405.387.102.168.153.387.153.657v2.394c0 .18.01.312.027.396.024.084.096.126.216.126a.758.758 0 00.234-.045v.594zm-1.242-2.385a1 1 0 01-.378.162c-.156.03-.32.057-.495.081a8.096 8.096 0 00-.513.072 1.78 1.78 0 00-.468.126.87.87 0 00-.342.261c-.084.108-.126.258-.126.45a.68.68 0 00.072.324c.054.084.12.153.198.207.084.054.18.093.288.117.108.024.222.036.342.036.252 0 .468-.033.648-.099.18-.072.327-.159.441-.261.114-.108.198-.222.252-.342a.896.896 0 00.081-.351v-.783zm2.692.117c0-.228.024-.45.072-.666.048-.216.126-.408.234-.576.108-.168.252-.303.432-.405.18-.102.4-.153.657-.153.264 0 .49.051.675.153.186.096.336.225.45.387.12.162.207.351.261.567a2.628 2.628 0 010 1.296c-.048.21-.129.399-.243.567a1.336 1.336 0 01-.44.396c-.18.102-.4.153-.658.153-.246 0-.462-.048-.648-.144a1.334 1.334 0 01-.45-.387 1.856 1.856 0 01-.26-.549 2.556 2.556 0 01-.082-.639zm3.6 2.286V8.074h-.765v2.394h-.018a1.148 1.148 0 00-.315-.342 1.481 1.481 0 00-.387-.225 1.818 1.818 0 00-.414-.126 2.266 2.266 0 00-.387-.036c-.354 0-.666.066-.936.198-.264.126-.486.3-.666.522a2.258 2.258 0 00-.396.765 3.392 3.392 0 00-.126.936c0 .33.045.642.135.936.09.294.222.552.396.774.18.222.402.399.666.531.27.132.585.198.945.198.324 0 .621-.057.891-.171.27-.114.468-.3.594-.558h.018v.63h.765zm4.6-2.322c0-.282.036-.531.108-.747.078-.222.183-.408.315-.558a1.334 1.334 0 011.026-.459c.198 0 .384.039.558.117.18.078.336.192.468.342.132.15.234.336.306.558.078.216.117.465.117.747s-.039.534-.117.756a1.572 1.572 0 01-.306.549 1.363 1.363 0 01-.468.333 1.411 1.411 0 01-1.125 0 1.387 1.387 0 01-.459-.333 1.689 1.689 0 01-.315-.549 2.447 2.447 0 01-.108-.756zm-.81 0c0 .342.048.66.144.954.096.294.24.552.432.774.192.216.43.387.711.513.282.12.606.18.972.18.372 0 .696-.06.972-.18.282-.126.52-.297.711-.513.192-.222.336-.48.432-.774.096-.294.144-.612.144-.954 0-.342-.048-.66-.144-.954-.096-.3-.24-.558-.432-.774a2.01 2.01 0 00-.71-.522 2.322 2.322 0 00-.973-.189c-.366 0-.69.063-.972.189a2.01 2.01 0 00-.71.522 2.121 2.121 0 00-.433.774 3.057 3.057 0 00-.144.954zm5.6-2.331V14.5h.765v-2.628c0-.21.027-.402.081-.576.06-.18.147-.336.261-.468.114-.132.255-.234.423-.306.174-.072.378-.108.612-.108.294 0 .525.084.693.252.168.168.252.396.252.684v3.15h.765v-3.06c0-.252-.027-.48-.08-.684a1.262 1.262 0 00-.262-.54 1.258 1.258 0 00-.495-.351 2.02 2.02 0 00-.765-.126c-.69 0-1.194.282-1.512.846h-.018v-.738h-.72zm8.928 0V8.452h-.765v1.395h-.792v.675h.792v2.961c0 .216.02.39.063.522a.651.651 0 00.189.306c.09.072.204.123.342.153.144.024.315.036.513.036h.585v-.675h-.351c-.12 0-.22-.003-.297-.009a.408.408 0 01-.171-.063.245.245 0 01-.09-.126 1.035 1.035 0 01-.018-.216v-2.889h.927v-.675h-.927zm1.957-1.773V14.5h.765v-2.628c0-.21.027-.402.081-.576.06-.18.147-.336.261-.468.114-.132.255-.234.423-.306.174-.072.378-.108.612-.108.294 0 .525.084.693.252.168.168.252.396.252.684v3.15h.765v-3.06c0-.252-.027-.48-.081-.684a1.262 1.262 0 00-.261-.54 1.258 1.258 0 00-.495-.351 2.02 2.02 0 00-.765-.126c-.138 0-.282.015-.432.045-.144.03-.285.078-.423.144-.132.06-.252.141-.36.243a.975.975 0 00-.252.36h-.018V8.074h-.765zm8.412 3.654h-2.673c.012-.18.051-.348.117-.504.066-.162.156-.303.27-.423.114-.12.249-.213.405-.279.162-.072.342-.108.54-.108.192 0 .366.036.522.108.162.066.3.159.414.279.12.114.213.252.279.414.072.162.114.333.126.513zm.738 1.296h-.756c-.066.306-.204.534-.414.684-.204.15-.468.225-.792.225-.252 0-.471-.042-.657-.126a1.314 1.314 0 01-.459-.333 1.363 1.363 0 01-.261-.486 1.887 1.887 0 01-.072-.585h3.483a3.57 3.57 0 00-.081-.891 2.46 2.46 0 00-.342-.864 1.94 1.94 0 00-.657-.648c-.27-.174-.612-.261-1.026-.261-.318 0-.612.06-.882.18-.264.12-.495.288-.693.504a2.365 2.365 0 00-.45.765 2.8 2.8 0 00-.162.972c.012.354.063.681.153.981.096.3.237.558.423.774.186.216.414.384.684.504.276.12.6.18.972.18.528 0 .966-.132 1.314-.396.348-.264.573-.657.675-1.179z",
    fill: "#666"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M56.92 21.977c2.298 0 3.812 1.816 3.812 4.622 0 2.813-1.505 4.62-3.778 4.62a3.07 3.07 0 01-2.849-1.583h-.042v4.484h-1.859V22.071h1.799v1.506h.034a3.212 3.212 0 012.883-1.6zm9.965 0c2.298 0 3.812 1.816 3.812 4.622 0 2.813-1.506 4.62-3.778 4.62a3.07 3.07 0 01-2.849-1.583h-.043v4.484H62.17V22.071h1.799v1.506h.034a3.212 3.212 0 012.883-1.6zM80.227 18.5c2.624 0 4.422 1.472 4.483 3.614h-1.876c-.112-1.239-1.137-1.987-2.634-1.987-1.497 0-2.521.757-2.521 1.858 0 .878.654 1.395 2.255 1.79l1.368.336c2.548.603 3.606 1.626 3.606 3.443 0 2.323-1.85 3.778-4.794 3.778-2.754 0-4.613-1.42-4.733-3.667h1.902c.138 1.232 1.334 2.04 2.969 2.04 1.566 0 2.693-.808 2.693-1.919 0-.964-.68-1.54-2.289-1.936l-1.61-.388c-2.28-.55-3.338-1.617-3.338-3.348 0-2.142 1.867-3.614 4.519-3.614zm15.705 3.46c2.625 0 4.295 1.79 4.295 4.639 0 2.856-1.662 4.638-4.295 4.638s-4.294-1.782-4.294-4.638c0-2.849 1.677-4.639 4.294-4.639zm15.048 0c2.505 0 4.081 1.72 4.081 4.466v.637h-6.395v.112a2.357 2.357 0 002.436 2.564 2.047 2.047 0 002.09-1.273h1.765c-.25 1.643-1.851 2.771-3.898 2.771-2.634 0-4.269-1.764-4.269-4.595 0-2.84 1.644-4.682 4.19-4.682zm-22.061-2.031v2.142h1.722v1.472h-1.722v4.991c0 .776.345 1.137 1.102 1.137.204-.004.408-.018.61-.043v1.463c-.34.063-.685.092-1.031.086-1.833 0-2.548-.689-2.548-2.445v-5.189h-1.317v-1.472h1.317V19.93h1.867zm-42.353-1.222l4.484 12.418h-2.04l-1.135-3.356h-4.733l-1.137 3.356H40l4.483-12.418h2.083zm59.186 3.27c.214-.001.428.022.637.069v1.738a2.604 2.604 0 00-.835-.112 1.874 1.874 0 00-1.937 2.083v5.37h-1.858v-9.054h1.772v1.541h.043a2.16 2.16 0 012.178-1.635zm-9.82 1.514c-1.506 0-2.4 1.162-2.4 3.108 0 1.962.894 3.106 2.4 3.106 1.505 0 2.401-1.144 2.401-3.106 0-1.954-.895-3.108-2.401-3.108zm-39.502.07c-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.392-1.197 2.392-3.046 0-1.833-.947-3.038-2.392-3.038zm9.964 0c-1.42 0-2.375 1.23-2.375 3.038 0 1.824.956 3.046 2.375 3.046 1.446 0 2.393-1.197 2.393-3.046 0-1.833-.947-3.038-2.393-3.038zm-20.86-2.788h-.051l-1.851 5.447h3.752l-1.85-5.447zm65.446 2.693a2.29 2.29 0 00-2.305 2.298h4.526a2.178 2.178 0 00-2.221-2.298z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M6 1h118v-2H6v2zm123 5v28h2V6h-2zm-5 33H6v2h118v-2zM1 34V6h-2v28h2zm5 5a5 5 0 01-5-5h-2a7 7 0 007 7v-2zm123-5a5 5 0 01-5 5v2a7 7 0 007-7h-2zm-5-33a5 5 0 015 5h2a7 7 0 00-7-7v2zM6-1a7 7 0 00-7 7h2a5 5 0 015-5v-2z",
    fill: "#A6A6A6"
  })));
}
/* harmony default export */ var apple_store = (SvgAppleStore);
;// CONCATENATED MODULE: ./public/svg/stores/google-play.svg
var google_play_path, google_play_path2, google_play_path3, _g, google_play_path4, _g2, google_play_path5, _g3, _path6, _path7, _path8, _defs;
function google_play_extends() { google_play_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return google_play_extends.apply(this, arguments); }

function SvgGooglePlay(props) {
  return /*#__PURE__*/react.createElement("svg", google_play_extends({
    width: 130,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), google_play_path || (google_play_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 6a6 6 0 016-6h118a6 6 0 016 6v28a6 6 0 01-6 6H6a6 6 0 01-6-6V6z",
    fill: "#fff"
  })), google_play_path2 || (google_play_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.435 7.548c-.291.308-.462.785-.462 1.404V31.05c0 .619.17 1.096.462 1.404l.074.072 12.379-12.38v-.291L9.508 7.475l-.073.073z",
    fill: "#00D7FE"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "google-play_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 12,
    height: 10
  }, google_play_path3 || (google_play_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M26.012 24.274l-4.125-4.128v-.291l4.127-4.128 4.982 2.83c1.396.795 1.396 2.093 0 2.886l-4.89 2.777-.094.055z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#google-play_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.012 24.274l-4.125-4.128v-.291l4.127-4.128 4.982 2.83c1.396.795 1.396 2.093 0 2.886l-4.89 2.777-.094.055z",
    fill: "url(#google-play_svg__paint0_linear_957_10620)"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "google-play_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 20,
    width: 18,
    height: 13
  }, google_play_path4 || (google_play_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M26.108 24.22L21.889 20 9.437 32.453c.46.487 1.22.547 2.076.061l14.596-8.294z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#google-play_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.108 24.22L21.889 20 9.437 32.453c.46.487 1.22.547 2.076.061l14.596-8.294z",
    fill: "url(#google-play_svg__paint1_linear_957_10620)"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "google-play_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 18,
    height: 13
  }, google_play_path5 || (google_play_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M26.108 15.78L11.512 7.486c-.856-.486-1.615-.426-2.076.061L21.889 20l4.22-4.22z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#google-play_svg__c)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.108 15.78L11.512 7.486c-.856-.486-1.615-.426-2.076.061L21.889 20l4.22-4.22z",
    fill: "url(#google-play_svg__paint2_linear_957_10620)"
  }))), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.894 30.953h1.866V18.452h-1.866v12.501zm16.807-7.998l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.329 7.575-1.898 4.214h1.947l5.13-11.789h-2.075zm-10.582 6.578c-.612 0-1.464-.305-1.464-1.061 0-.965 1.062-1.335 1.978-1.335.821 0 1.206.177 1.705.418a2.262 2.262 0 01-2.219 1.978zm.225-6.851c-1.351 0-2.75.595-3.329 1.914l1.656.691c.354-.691 1.013-.917 1.705-.917.965 0 1.946.579 1.962 1.609v.128c-.338-.193-1.061-.482-1.946-.482-1.785 0-3.603.981-3.603 2.814 0 1.673 1.464 2.751 3.104 2.751 1.255 0 1.946-.563 2.381-1.223h.064v.965h1.801V26.14c0-2.22-1.656-3.458-3.795-3.458zm-11.532 1.795h-2.654v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .969-.792 2.143-2.187 2.143zm-.048-6.025h-4.471v12.501h1.865v-4.736h2.606c2.068 0 4.101-1.498 4.101-3.883s-2.033-3.882-4.101-3.882zM74.383 29.535c-1.289 0-2.368-1.079-2.368-2.561 0-1.498 1.079-2.594 2.368-2.594 1.273 0 2.271 1.096 2.271 2.594 0 1.482-.998 2.561-2.271 2.561zm2.142-5.88h-.064c-.419-.499-1.224-.95-2.239-.95-2.127 0-4.076 1.868-4.076 4.269 0 2.384 1.949 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.967h.064v.612c0 1.628-.869 2.498-2.271 2.498-1.144 0-1.853-.822-2.143-1.515l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.191 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693zm3.062 7.298h1.869V18.451h-1.869v12.502zm4.623-4.124c-.048-1.643 1.273-2.481 2.223-2.481.742 0 1.37.37 1.579.902l-3.802 1.579zm5.8-1.418c-.354-.95-1.434-2.706-3.641-2.706-2.191 0-4.011 1.723-4.011 4.253 0 2.384 1.804 4.253 4.22 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.967c-.483.709-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.288l5.687-2.352-.193-.484zM44.702 24.01v1.804h4.317c-.129 1.015-.467 1.756-.982 2.272-.629.628-1.612 1.32-3.335 1.32-2.658 0-4.737-2.142-4.737-4.8 0-2.659 2.079-4.801 4.737-4.801 1.434 0 2.481.564 3.254 1.289l1.273-1.273C48.149 18.79 46.716 18 44.702 18 41.061 18 38 20.965 38 24.606s3.061 6.605 6.702 6.605c1.965 0 3.447-.644 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.221 0-.419-.032-.805-.097-1.127h-6.073zm11.079 5.525c-1.289 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.401-2.578 1.288 0 2.4 1.047 2.4 2.578 0 1.514-1.112 2.577-2.4 2.577zm0-6.83c-2.353 0-4.27 1.788-4.27 4.253 0 2.448 1.917 4.253 4.27 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.269-4.253zm9.313 6.83c-1.289 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.401-2.578 1.289 0 2.4 1.047 2.4 2.578 0 1.514-1.111 2.577-2.4 2.577zm0-6.83c-2.352 0-4.269 1.788-4.269 4.253 0 2.448 1.917 4.253 4.269 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.269-4.253z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M43.471 10.814v2.342a2.08 2.08 0 01-.378.396c-.173.143-.411.27-.716.378-.302.105-.692.158-1.169.158-.39 0-.748-.067-1.077-.202a2.429 2.429 0 01-.848-.598 2.8 2.8 0 01-.553-.958 3.964 3.964 0 01-.194-1.283v-.497c0-.477.056-.904.167-1.279.114-.375.281-.692.501-.953a2.1 2.1 0 01.809-.598c.319-.137.685-.206 1.098-.206.49 0 .898.085 1.226.255.331.167.59.398.774.694.187.296.308.633.36 1.01h-.848a1.777 1.777 0 00-.228-.632 1.221 1.221 0 00-.48-.457c-.207-.117-.475-.176-.804-.176a1.7 1.7 0 00-.769.163 1.415 1.415 0 00-.536.465c-.14.203-.246.447-.316.734-.068.287-.101.611-.101.971v.506c0 .369.042.699.127.989.088.29.212.537.374.742a1.614 1.614 0 001.322.62c.302 0 .547-.025.734-.075.188-.053.334-.114.44-.184a1.3 1.3 0 00.241-.207V11.5h-1.48v-.685h2.324zm5.201 2.496V14h-3.388v-.69h3.388zm-3.216-5.708V14h-.849V7.602h.849zm2.768 2.75v.69h-2.94v-.69h2.94zm.404-2.75v.694h-3.344v-.694h3.344zm3.277 0V14h-.835V7.602h.835zm2.056 0v.694h-4.943v-.694h4.944zm3.376 0V14h-.848V7.602h.848zm3.505 0V14h-.835V7.602h.835zm2.056 0v.694h-4.943v-.694h4.944zm7.393 2.997v.404c0 .48-.06.911-.18 1.292-.12.38-.294.704-.52.971a2.25 2.25 0 01-.812.611c-.313.14-.665.21-1.055.21-.378 0-.725-.07-1.041-.21a2.342 2.342 0 01-.818-.61 2.846 2.846 0 01-.531-.972 4.106 4.106 0 01-.19-1.292v-.404c0-.48.062-.91.185-1.288.126-.38.303-.705.532-.971.228-.27.5-.475.813-.615.316-.141.663-.211 1.041-.211.39 0 .742.07 1.055.21.317.141.588.346.813.616.229.266.403.59.523.971.123.378.185.807.185 1.288zm-.84.404v-.413c0-.381-.04-.718-.118-1.01a2.096 2.096 0 00-.339-.74 1.46 1.46 0 00-.549-.452 1.667 1.667 0 00-.73-.154c-.263 0-.502.052-.716.154a1.517 1.517 0 00-.545.453c-.15.199-.265.445-.347.738-.082.293-.123.63-.123 1.01v.414c0 .384.041.724.123 1.02.082.292.2.54.352.742.155.2.338.35.549.453.214.102.453.154.716.154.276 0 .52-.052.734-.154.214-.103.394-.254.54-.453.15-.202.263-.45.34-.742a4.11 4.11 0 00.113-1.02zm6.762-3.401V14h-.853l-3.221-4.935V14h-.848V7.602h.848l3.234 4.948V7.602h.84z",
    fill: "#666"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M6 1h118v-2H6v2zm123 5v28h2V6h-2zm-5 33H6v2h118v-2zM1 34V6h-2v28h2zm5 5a5 5 0 01-5-5h-2a7 7 0 007 7v-2zm123-5a5 5 0 01-5 5v2a7 7 0 007-7h-2zm-5-33a5 5 0 015 5h2a7 7 0 00-7-7v2zM6-1a7 7 0 00-7 7h2a5 5 0 015-5v-2z",
    fill: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "google-play_svg__paint0_linear_957_10620",
    x1: 30.087,
    y1: 20.001,
    x2: 21.887,
    y2: 20.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA03"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "google-play_svg__paint1_linear_957_10620",
    x1: 23.815,
    y1: 23.971,
    x2: 13.112,
    y2: 32.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#E22652"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A44"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "google-play_svg__paint2_linear_957_10620",
    x1: 11.321,
    y1: 9.046,
    x2: 18.457,
    y2: 15.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#0ED574"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#07F076"
  })))));
}
/* harmony default export */ var google_play = (SvgGooglePlay);
// EXTERNAL MODULE: ./styles/utils.ts
var utils = __webpack_require__(45500);
// EXTERNAL MODULE: ./components/logo/logo.tsx + 1 modules
var logo = __webpack_require__(49965);
// EXTERNAL MODULE: ./components/icon/icon.tsx + 175 modules
var icon_icon = __webpack_require__(32079);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid.js + 1 modules
var flex_grid = __webpack_require__(46322);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid-item.js
var flex_grid_item = __webpack_require__(11524);
// EXTERNAL MODULE: ./styles/media-query.ts
var media_query = __webpack_require__(97475);
// EXTERNAL MODULE: ./components/footer/menus.ts
var menus = __webpack_require__(1749);
// EXTERNAL MODULE: ./components/base-block/base-block.tsx
var base_block = __webpack_require__(94306);
// EXTERNAL MODULE: ./styles/z-indexes.ts
var z_indexes = __webpack_require__(9227);
// EXTERNAL MODULE: ./modules/users/hooks/use-me.tsx
var use_me = __webpack_require__(17243);
;// CONCATENATED MODULE: ./components/footer/footer.tsx


























var Footer = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref[0];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var me = (0,use_me/* useMe */.P)().me;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: css((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: "100%",
            backgroundColor: colors/* colors.gray50 */.O.gray50
        }, (0,polished_esm/* padding */.o3)("64px", 0)), {
            boxSizing: "border-box",
            zIndex: z_indexes/* zIndexes.footer */.U.footer,
            marginTop: "200px"
        })),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_grid/* BaseGrid */.w, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_cell/* BaseCell */.q, {
                span: [
                    4,
                    8,
                    12
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: css((0,_define_property/* default */.Z)({
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "48px"
                        }, media_query/* mediaQuery.DESKTOP */.c.DESKTOP, {
                            flexDirection: "row",
                            columnGap: "16px"
                        })),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(block/* default */.Z, {
                                width: "100%",
                                maxWidth: "248px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                                    size: "m"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(block/* default */.Z, {
                                flex: "1 1 auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid/* default */.Z, {
                                    flexGridColumnCount: [
                                        2,
                                        2,
                                        4,
                                        3
                                    ],
                                    flexGridColumnGap: "16px",
                                    flexGridRowGap: "48px",
                                    children: menus/* footerMenus.map */.Q.map(function(param) {
                                        var title = param.title, menus = param.menus;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(flex_grid_item/* default */.ZP, {
                                            className: css({
                                                display: "flex",
                                                flexDirection: "column",
                                                rowGap: "12px",
                                                alignItems: "flex-start"
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(base_typography_label/* LabelS */.ew, {
                                                    weight: 700,
                                                    marginBottom: "8px",
                                                    children: title
                                                }),
                                                menus.map(function(param) {
                                                    var label = param.label, href = param.href, role = param.role, blank = param.blank;
                                                    return (me === null || me === void 0 ? void 0 : me.role) ? !(role === null || role === void 0 ? void 0 : role.includes(me.role)) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: href,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: blank ? "_blank" : undefined,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_typography_label/* LabelS */.ew, {
                                                                color: colors/* colors.gray500 */.O.gray500,
                                                                $style: {
                                                                    ":hover": {
                                                                        textDecoration: "underline"
                                                                    }
                                                                },
                                                                children: label
                                                            })
                                                        })
                                                    }, label) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: href,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: blank ? "_blank" : undefined,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_typography_label/* LabelS */.ew, {
                                                                color: colors/* colors.gray500 */.O.gray500,
                                                                $style: {
                                                                    ":hover": {
                                                                        textDecoration: "underline"
                                                                    }
                                                                },
                                                                children: label
                                                            })
                                                        })
                                                    }, label);
                                                })
                                            ]
                                        }, title);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(block/* default */.Z, {
                                className: css((0,_define_property/* default */.Z)({
                                    display: "flex",
                                    columnGap: "12px",
                                    maxWidth: "248px",
                                    width: "100%"
                                }, media_query/* mediaQuery.DESKTOP */.c.DESKTOP, {
                                    alignItems: "flex-start",
                                    justifyContent: "flex-end"
                                })),
                                children: menus/* socialMedia.map */.L.map(function(param) {
                                    var label = param.label, href = param.href, icon = param.icon;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: href,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            "aria-label": label,
                                            target: "_blank",
                                            className: css((0,_object_spread/* default */.Z)({
                                                display: "flex"
                                            }, (0,polished_esm/* padding */.o3)("2px"), (0,utils/* borderRadius */.E0)(32))),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_icon/* Icon */.J, {
                                                type: icon,
                                                color: colors/* colors.gray400 */.O.gray400
                                            })
                                        })
                                    }, label);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                        marginTop: [
                            "48px",
                            "48px",
                            "48px",
                            "120px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: css((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    border: "none",
                                    backgroundColor: "transparent"
                                }, (0,polished_esm/* padding */.o3)("0px")), {
                                    display: "flex",
                                    alignItems: "center",
                                    columnGap: "4px",
                                    cursor: "pointer",
                                    marginBottom: "8px"
                                })),
                                onClick: function() {
                                    setIsOpen(function(prev) {
                                        return !prev;
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(base_typography_label/* LabelXS */.Ei, {
                                        color: colors/* colors.gray500 */.O.gray500,
                                        children: "(주) 테서 사업자 정보"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_icon/* Icon */.J, {
                                        type: isOpen ? "ChevronUp" : "ChevronDown",
                                        size: 12,
                                        color: colors/* colors.gray500 */.O.gray500
                                    })
                                ]
                            }),
                            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* ParagraphXS */.Sj, {
                                color: colors/* colors.gray500 */.O.gray500,
                                marginBottom: "8px",
                                $style: (0,_define_property/* default */.Z)({}, media_query/* mediaQuery.TABLET */.c.TABLET, {
                                    whiteSpace: "pre"
                                }),
                                children: "(주) 테서 | 대표이사: 이수현 | 사업자등록번호: 404-81-46323 | 주소: 서울시 강남구 언주로 544, 삼본빌딩 4F \n연락처: +82-2-575-1593 | tesser@tesser.co.kr"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                                className: css((0,_define_property/* default */.Z)({
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                    rowGap: "48px"
                                }, media_query/* mediaQuery.TABLET */.c.TABLET, {
                                    flexDirection: "row"
                                })),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(block/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                                                display: "flex",
                                                alignItems: "center",
                                                columnGap: "10px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyLink, {
                                                        label: "서비스 이용약관",
                                                        href: routes/* Routes.LEGAL_TERMS_OF_SERVICE */.Z.LEGAL_TERMS_OF_SERVICE
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(block/* default */.Z, {
                                                        width: "1px",
                                                        height: "10px",
                                                        backgroundColor: colors/* colors.gray400 */.O.gray400
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyLink, {
                                                        label: "개인정보 취급방침",
                                                        href: routes/* Routes.LEGAL_PRIVACY_POLICY */.Z.LEGAL_PRIVACY_POLICY
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(base_typography_label/* LabelXS */.Ei, {
                                                marginTop: "8px",
                                                color: colors/* colors.gray500 */.O.gray500,
                                                children: "ⓒ 2022 Tesser Corp. All rights reserved."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(block/* default */.Z, {
                                        className: css({
                                            display: "flex",
                                            alignItems: "center",
                                            columnGap: "10px"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.PLAY_STORE */.Z.PLAY_STORE,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    "aria-label": "google play",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_play, {
                                                        className: css((0,_object_spread/* default */.Z)({}, (0,utils/* borderRadius */.E0)(6)))
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.APP_STORE */.Z.APP_STORE,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    "aria-label": "apple store",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(apple_store, {
                                                        className: css((0,_object_spread/* default */.Z)({}, (0,utils/* borderRadius */.E0)(6)))
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var PolicyLink = function(param) {
    var href = param.href, label = param.label;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            target: "_blank",
            className: css({
                fontSize: "12px",
                lineHeight: "16px",
                color: colors/* colors.gray500 */.O.gray500
            }),
            children: label
        })
    });
};


/***/ }),

/***/ 1749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ socialMedia; },
/* harmony export */   "Q": function() { return /* binding */ footerMenus; }
/* harmony export */ });
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60369);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78954);


var footerMenus = [
    {
        title: "메뉴",
        menus: [
            {
                label: "해석 신청",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.UPLOAD */ .Z.UPLOAD
            },
            {
                label: "내 검사 결과지",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.PATIENT_EXAMINATIONS */ .Z.PATIENT_EXAMINATIONS
            },
            // {
            //   label: '이용 가이드',
            //   href: Routes.NOTION_GUIDE,
            //   blank: true,
            // },
            {
                label: "설정",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.SETTINGS_ACCOUNT */ .Z.SETTINGS_ACCOUNT
            }, 
        ]
    },
    {
        title: "문의",
        menus: [
            {
                label: "해석 참여 신청",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.DOCTOR_REGISTRATION */ .Z.DOCTOR_REGISTRATION,
                role: [
                    _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_1__/* .UserRole.Professional */ .i4.Professional
                ]
            },
            {
                label: "제휴 문의",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.SUPPORT_INQUIRY_WRITE */ .Z.SUPPORT_INQUIRY_WRITE
            }, 
        ]
    },
    {
        title: "고객지원",
        menus: [
            {
                label: "공지사항",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.SUPPORT_NOTICE */ .Z.SUPPORT_NOTICE
            },
            {
                label: "자주 묻는 질문",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.SUPPORT_FAQ */ .Z.SUPPORT_FAQ
            },
            {
                label: "1대1 문의",
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_0__/* .Routes.SUPPORT_INQUIRY_WRITE */ .Z.SUPPORT_INQUIRY_WRITE
            }, 
        ]
    }, 
];
var socialMedia = [
    {
        label: "facebook",
        icon: "Facebook",
        colorIcon: "FacebookColor",
        href: "https://www.facebook.com/tesserinc"
    },
    {
        label: "instagram",
        icon: "Instagram",
        colorIcon: "InstagramColor",
        href: "https://www.instagram.com/tesserdata"
    },
    {
        label: "blog",
        icon: "Naver",
        colorIcon: "NaverColor",
        href: "https://blog.naver.com/tesserinc"
    }, 
];


/***/ }),

/***/ 51774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useScrollPoint; }
/* harmony export */ });
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23493);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var useScrollPoint = function() {
    var point = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPoint = ref[0], setIsPoint = ref[1];
    var setPointHeader = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(function() {
            var isReachPoint = window.scrollY > point;
            if (isReachPoint !== isPoint) setIsPoint(isReachPoint);
        }, 300);
    }, [
        isPoint,
        point
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", setPointHeader);
        return function() {
            window.removeEventListener("scroll", setPointHeader);
        };
    }, [
        isPoint,
        setPointHeader
    ]);
    return {
        isPoint: isPoint
    };
};


/***/ })

}]);